'use es6';

import AnnotationType from 'react-codemirror/enum/AnnotationType';
/**
 * Sorts numbers
 *
 * @param  {Number} a
 * @param  {Number} b
 * @return {Number}
 */

export function numberSorter(a, b) {
  if (a > b) return 1;
  if (a < b) return -1;
  return 0;
}
/**
 * Sorts ascending by lineNumber, column, type
 *
 * @param  {Annotation} annoA
 * @param  {Annotation} annoB
 * @return {Number}
 */

export function annotationsSorter({
  lineNumber: lineA,
  column: colA,
  type: typeA
}, {
  lineNumber: lineB,
  column: colB,
  type: typeB
}) {
  if (lineA > lineB) return 1;
  if (lineA < lineB) return -1;

  if (typeA !== typeB) {
    if (typeA === AnnotationType.ERROR) return -1;
    if (typeB === AnnotationType.ERROR) return 1;
    if (typeA === AnnotationType.WARNING) return -1;
    if (typeB === AnnotationType.WARNING) return 1;
  }

  if (colA > colB) return 1;
  if (colA < colB) return -1;
  return 0;
}
/**
 * Sorts ascending by line, ch
 *
 * @param  {CodeMirror.Pos} posA
 * @param  {CodeMirror.Pos} posB
 * @return {Number}
 */

export function posSorter({
  line: lineA,
  ch: chA
}, {
  line: lineB,
  ch: chB
}) {
  if (lineA > lineB) return 1;
  if (lineA < lineB) return -1;
  if (chA > chB) return 1;
  if (chA < chB) return -1;
  return 0;
}